// extracted by mini-css-extract-plugin
module.exports = {"interlinking":"TextBlock_interlinking__l59XM","title":"TextBlock_title__AYG1Q","layout":"TextBlock_layout__gCO_X"};